import { ActivityFeedNotifications } from "../activity-feed/ActivityFeedEventType"

export type ActivityFeedEventSearchResultDto = {
    accountId: string
    activityType: ActivityFeedNotifications
    contact: {name: string}
    contactId: string
    createdAt: string
    createdByUser: { name: string }
    createdByUserId: string
    id: string
    identifier: string
    isArchived: boolean
    objectId: string
    objectType: string
    testData: boolean
    objectDataJson: string
    _type: string
}

export default class ActivityFeedEventSearchResult {
    private dto: ActivityFeedEventSearchResultDto

    constructor(dto: ActivityFeedEventSearchResultDto) {
        this.dto = dto
    }

    getAccountId(): string {
        return this.dto.accountId
    }

    getActivityType(): ActivityFeedNotifications {
        return this.dto.activityType
    }

    getContact(): { name: string } {
        return this.dto.contact
    }

    getContactName(): string {
        return this.getContact().name
    }

    getContactId(): string {
        return this.dto.contactId
    }

    getCreatedAt(): string {
        return this.dto.createdAt
    }

    getCreatedByUser(): { name: string } {
        return this.dto.createdByUser
    }

    getCreatedByUserName(): string {
        return this.getCreatedByUser().name
    }

    getCreatedByUserId(): string {
        return this.dto.createdByUserId
    }

    getId(): string {
        return this.dto.id
    }

    getIdentifier(): string {
        return this.dto.identifier
    }

    getIsArchived(): boolean {
        return this.dto.isArchived
    }

    getObjectId(): string {
        return this.dto.objectId
    }

    getObjectType(): string {
        return this.dto.objectType
    }

    getTestData(): boolean {
        return this.dto.testData
    }

    getObjectDataJson(): string {
        return this.dto.objectDataJson
    }

    getType(): string {
        return this.dto._type
    }
}


// WEBPACK FOOTER //
// ./src/state/search/Dto.ts